import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';
import { HomepageRoute } from 'src/public/publicRoutes';
import { Button } from 'src/common/components/Button';
import { GatsbyLink } from 'src/common/migration/GatsbyLink';
import Image from 'next/image';
import { StoredImageDTO } from 'src/common/models/image';

const Avatar = styled.div`
  flex: 0 0 auto;
  height: 3.875rem;
  margin-right: 0.625rem;
  position: relative;
  width: 3.875rem;

  ${media.w.min.px768(css`
    margin-right: 0;
    margin-top: 2.5rem;
  `)};
`;

const AvatarImage = styled(Image)`
  border-radius: 50%;
  object-fit: contain;
`;

const SpeakerCard = styled.div`
  font-size: 0.625rem;
  line-height: 0.875rem;

  ${media.w.min.px768(css`
    margin: 1.25rem 0 1.0625rem;
  `)};
`;

const SpeakerContainer = styled.div<{ horizontal?: boolean }>`
  ${({ horizontal }) =>
    horizontal &&
    css`
      align-items: center;
      display: flex;
    `}

  ${media.w.max.px768(css`
    align-items: center;
    display: flex;
  `)};

  ${Avatar} {
    margin-right: 1.25rem;
    ${media.w.min.px768(css`
      margin-right: 1.25rem;
      margin-top: 0;
      width: 3.875rem;
    `)};
  }
`;

const StyledLink = styled(Button)`
  font-weight: 700;
`;

export interface SpeakerInfoProps {
  horizontal?: boolean;
  avatarImg?: StoredImageDTO;
  alt?: string;
  speakerName: string;
  speakerCompany: string;
  linkTo: string;
}

export const SpeakerInfo: FC<SpeakerInfoProps> = ({
  horizontal = false,
  avatarImg,
  speakerName,
  speakerCompany,
  linkTo = HomepageRoute,
}) => (
  <SpeakerContainer horizontal={horizontal}>
    {avatarImg && (
      <Avatar>
        <GatsbyLink to={linkTo}>
          <AvatarImage alt={speakerName} layout="fill" src={avatarImg.url} />
        </GatsbyLink>
      </Avatar>
    )}

    <SpeakerCard>
      <StyledLink decoration="underline" kind="link" as={GatsbyLink} to={linkTo}>
        {speakerName}
      </StyledLink>
      <br />
      {speakerCompany}
    </SpeakerCard>
  </SpeakerContainer>
);
